
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community/post/[slug]",
      function () {
        return require("private-next-pages/community/post/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community/post/[slug]"])
      });
    }
  